module.exports = __webpack_public_path__ + "static/media/ayna.b65e450e.png";